import { render, staticRenderFns } from "./TopNftsCard.vue?vue&type=template&id=00b210c4&scoped=true"
import script from "./TopNftsCard.vue?vue&type=script&lang=ts"
export * from "./TopNftsCard.vue?vue&type=script&lang=ts"
import style0 from "./TopNftsCard.vue?vue&type=style&index=0&id=00b210c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b210c4",
  null
  
)

export default component.exports